import * as Sentry from '@sentry/react'

import { createStore, compose, applyMiddleware } from 'redux'

import { persistStore, persistReducer } from 'redux-persist'

import storage from 'redux-persist/lib/storage'

import createSagaMiddleware from 'redux-saga'

import rootReducer from './ducks'

import rootSaga from './sagas'

const persistConfig = {
  key: 'root',
  storage,
  timeout: null,
  whitelist: ['cart', 'checkout']
}

const sagaMiddleware = createSagaMiddleware()

const persistedReducer = persistReducer(persistConfig, rootReducer)

const sentryReduxEnhancer = Sentry.createReduxEnhancer()

const store = createStore(
  persistedReducer,
  compose(applyMiddleware(sagaMiddleware), sentryReduxEnhancer)
)

const persistor = persistStore(store)

sagaMiddleware.run(rootSaga)

export { store, persistor }
